export class StreamPlainObject {
    constructor(public name?: string) {
    }
}
